<div class="wm-left-panel-container">
  <div class="slider-panel">
    <ul class="slider-nav" id="wms-workspace-nav" [ngClass]="{'disable-pointer-events' : studioFactory.hasMergeChangesConflicts}">
      <li *wmsFeature="preferences.project?.resources.templates">
        <button name="wm-category-templates" [ngClass]="{'active': activeWSCategory === 'PAGE'}"
          (click)="switchWSCategory('PAGE', $event)" title="{{locale.LABEL_TEMPLATES}}">
          <i class="wm-icon24 wms wms-template"></i>
          <span class="title">{{locale.LABEL_TEMPLATES}}</span>
        </button>
      </li>

      <li *wmsFeature="preferences.project?.pages.view">
        <button [routerLink]="getRoutePath('PAGE')" name="wm-category-page-list"
                [ngClass]="{'active': activeWSCategory === 'PAGE' && pageWsService.pageSubCategory === 'LIST' && (isSubpage && getCurrentRouteInfo().parentRoute === 'page')}"
                title="{{locale.LABEL_PAGES}}" (click)="switchWSCategory('PAGE', $event,'LIST')" queryParamsHandling="replace" [queryParams]="qParams">
          <i class="wm-icon24 wms wms-pages"></i>
        </button>
      </li>

      <li *wmsFeature="preferences.project?.pages.view">
        <button [routerLink]="getRoutePath('PAGE')" name="wm-category-page-build"
          [ngClass]="{'active': activeWSCategory === 'PAGE' && pageWsService.pageSubCategory === 'BUILD' && (isSubpage && getCurrentRouteInfo().parentRoute === 'page')}"
          title="{{locale.LABEL_BUILDING_BLOCKS}}" (click)="switchWSCategory('PAGE', $event, 'BUILD')" queryParamsHandling="replace" [queryParams]="qParams">
          <i class="wm-icon24 wms wms-widgets-prefabs"></i>
        </button>
      </li>

      <li *wmsFeature="preferences.project?.pages.view">
        <button [routerLink]="getRoutePath('PAGE')" name="wm-category-page-structure"
                [ngClass]="{'active': activeWSCategory === 'PAGE' && pageWsService.pageSubCategory === 'STRUCTURE' && (isSubpage && getCurrentRouteInfo().parentRoute === 'page')}"
                title="{{locale.LABEL_PAGE_STRUCTURE}}" (click)="switchWSCategory('PAGE', $event,'STRUCTURE' )" queryParamsHandling="replace" [queryParams]="qParams">
          <i class="wm-icon24 wms wms-page-structure-new"></i>
        </button>
      </li>

      <li *wmsFeature="preferences.project?.database.view" id="wms-workspace-btn-db">
        <button [routerLink]="getRoutePath('DB')" name="wm-category-databases"
          [ngClass]="{'active': activeWSCategory === 'DB' || (isSubpage && getCurrentRouteInfo().parentRoute === 'database')}"
          title="{{locale.LABEL_DATABASE}}" (click)="switchWSCategory('DB', $event)" queryParamsHandling="replace"
                [queryParams]="qParams">
          <i class="wm-icon24 wms wms-database"></i>
        </button>
      </li>

      <li *wmsFeature="preferences.project?.datamodel.view" id="wms-workspace-btn-model">
        <button [routerLink]="getRoutePath('MODEL')" name="wm-category-databases"
          [ngClass]="{'active': activeWSCategory === 'MODEL'}" title="{{locale.LABEL_MODEL_DESIGNER}}"
          (click)="switchWSCategory('MODEL', $event)">
          <i class="wm-icon24 wms wms-model-designer"></i>
        </button>
      </li>

      <li *wmsFeature="preferences.project?.javaservice.view">
        <button [routerLink]="getRoutePath('JAVASERVICE')" name="wm-category-java-services"
          [ngClass]="{'active': activeWSCategory === 'JAVASERVICE' || (isSubpage && getCurrentRouteInfo().parentRoute === 'java-service')}"
          title="{{locale.LABEL_JAVA_SERVICE}}" (click)="switchWSCategory('JAVASERVICE', $event)"
          queryParamsHandling="replace" [queryParams]="qParams">
          <i class="wm-icon24 wms wms-java-service"></i>
        </button>
      </li>

      <li *wmsFeature="preferences.project?.apidesigner.view" id="wms-workspace-btn-api">
        <button [routerLink]="getRoutePath('APIDESIGNER')" name="wm-category-apis"
          [ngClass]="{'active': activeWSCategory === 'APIDESIGNER' || (isSubpage && getCurrentRouteInfo().parentRoute === 'apis')}"
          title="{{locale.LABEL_API_DESIGNER_TOOLTIP_TEAM}}" (click)="switchWSCategory('APIDESIGNER', $event)"
          queryParamsHandling="replace" [queryParams]="qParams">
          <i class="wm-icon24 wms wms-api-designer"></i>
        </button>
      </li>

      <li>
        <button [routerLink]="getRoutePath('SETTINGS')" name="wm-category-settings" [ngClass]="{
            'active': activeWSCategory === 'SETTINGS' ||
                     SETTINGS_TABS.includes(activeWSCategory) ||
                     (isSubpage && getCurrentRouteInfo().parentRoute === 'settings')
          }" title="{{locale.LABEL_HEADER_SETTINGS}}" (click)="switchWSCategory('SETTINGS', $event)"
          queryParamsHandling="replace" [queryParams]="qParams">
          <i class="wm-icon24 wms wms-settings"></i>
        </button>
      </li>
      <li>
        <button *ngIf="showStyleWorkspace" routerLink="/style"  routerLinkActive="active"  name="wm-category-style"
                [ngClass]="{active: (activeWSCategory === locale.LABEL_WORKSPACE_STYLE || STYLE_TABS.includes(activeWSCategory))}" (click)="switchWSCategory('STYLE',$event)"
            title="{{locale.LABEL_WORKSPACE_STYLE}}" queryParamsHandling="replace" [queryParams]="qParams">
          <i class="wm-icon24 wms wms-styles"></i>
        </button>
      </li>
    </ul>

    <ul class="slider-nav aligned-bottom">
      <li *ngIf="studioFactory.showApplyMergeChangesWS">
        <button [routerLink]="getRoutePath('MERGECHANGES')" name="wm-catagory-merge-changes"
          [ngClass]="{'active': activeWSCategory === 'MERGECHANGES'}" title="{{locale.LABEL_MERGE_CHANGES}}"
          (click)="switchWSCategory('MERGECHANGES', $event)">
          <i class="wm-icon24 wms wms-merge-type"></i>
          <span *ngIf="!studioFactory.hasMergeChangesConflicts" class="changes-marker">*</span>
        </button>
      </li>
      <li *wmsFeature="preferences.project?.tools.fileexplorer?.view"
        [ngClass]="{'disable-pointer-events' : studioFactory.hasMergeChangesConflicts}">
        <button [routerLink]="getRoutePath('RESOURCE')" name="project.resources.files.project"
          [ngClass]="{'active': activeWSCategory === 'RESOURCE'}" title="{{locale.LABEL_FILE_EXPLORER}}"
          (click)="switchWSCategory('RESOURCE', $event)">
          <i class="wm-icon24 wms wms-folder"></i>
        </button>
      </li>

      <li title="{{locale.LABEL_DOWNLOAD_SERVER_LOGS}}">
        <button (click)="openLogsDialog()">
          <a>
            <i class="wm-icon24 wms wms-page-template"></i>
          </a>
        </button>
      </li>

      <li class="dropup more-menu" class="dropdown"
        [ngClass]="{'disable-pointer-events' : studioFactory.hasMergeChangesConflicts}" dropdown container="body"
        title="{{locale.LABEL_MORE}}">
        <button name="leftnav-more-action" class="dropdown-toggle" dropdownToggle>
          <i class="wm-icon24 wms wms-more-horiz"></i>
        </button>
        <wms-more-actions-menu *dropdownMenu></wms-more-actions-menu>
      </li>
    </ul>
  </div>
</div>

<wms-dialog id="shortcutsDialog" name="wm-studio-shortcuts-dailog" [content]="shortcutsContent"
  customClasses="wm-shortcuts-dialog wm-studio-dialog medium"></wms-dialog>
<ng-template #shortcutsContent>
  <wms-shortcuts-dialog (onModalClose)="closeDialogWithId('shortcutsDialog')"></wms-shortcuts-dialog>
</ng-template>

<wms-dialog id="importProjectDialog" name="wm-import-project-dialog" [content]="importProjectContent"
  [closeOnEscape]="false" customClasses="import-project-container-dialog app-confirm-dialog small wm-studio-dialog"></wms-dialog>
<ng-template #importProjectContent>
  <wms-import-project (onModalClose)="closeDialogWithId('importProjectDialog')" [reImport]="true"></wms-import-project>
</ng-template>

<wms-dialog id="logsViewDialog" [content]="logsViewDialog" customClasses="wm-studio-dialog x-large logs-view"> </wms-dialog>

<ng-template #logsViewDialog>
  <wms-logs-dialog [displayLogs]="displayLogs" (hideLogs)="handleHideLogs()"></wms-logs-dialog>
</ng-template>
